<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body">
      <div class="row">
        <div
            class="col-md-12 text-center modal-header px-4 align-items-center"
        >
          <div class="header-container row w-100 py-3">
            <h3 class="col-10 text-left ml-3 section-title">
              <span v-if="isContentPageDataLoading">Loading...</span>
              <span v-else-if="!isContentPageDataLoading && contentPage.id">{{ contentPage.title }}</span>
            </h3>
            <button class="close close-btn text-right col-1" @click="closePopup">
              <img src="../../assets/images/icon-close.svg" />
            </button>
          </div>
        </div>
      </div>
      <loading-spinner v-if="isContentPageDataLoading"></loading-spinner>
      <div class="row pt-3">
        <div class="col-md-12">
          <div class="rel-container">
            <div class="row preview-panel content-pages-panel px-3">
              <div class="col-12">
                <div class="alert-container mt-2" v-if="isContentPageLoadError">
                  <div class="fade-in-out alert alert-error" >
                    <div><strong>{{errorMessage}}</strong></div>
                  </div>
                </div>
                <div v-else-if="!isContentPageDataLoading && contentPage.id">
                  <froalaView v-model="contentPage.content"></froalaView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import api from "@/api";
import VueFroala from "vue-froala-wysiwyg";
import LoadingSpinner from "@/components/LoadingSpinner";
Vue.use(VueFroala);
import CONSTANTS from "@/store/constants";


export default {
  name: "SCWalkThroughModal",
  components: {LoadingSpinner},
  data(){
    return {
      contentPage:null,
      isContentPageDataLoading:true,
      CONTENT_PAGE_ALIAS:"working-with-a-supplier",
      isContentPageLoadError: false,
      errorMessage: CONSTANTS.ERROR_MESSAGE
    }
  },
  created(){
    this.getContentPageData();
  },
  methods :{
    closePopup(){
      this.$parent.$emit('onClosed')
    },
    getContentPageData(){
      this.isContentPageDataLoading = true
      api.getContentPage(this.CONTENT_PAGE_ALIAS).then(res=>{
        this.contentPage = res.data;
      }).catch(()=>{
        this.isContentPageLoadError = true
      }).finally(()=>{
        this.isContentPageDataLoading = false;
      })
    }
  },

}
</script>

<style scoped>

.modal-header {
  height: 100%;
}

table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: center;
}
.modal-container {
  background-color: #fff;
  overflow-y: auto !important;
  height: 100%;
  overflow-x: hidden;
}

.modal-container {
  padding-bottom: 20px;
}

@media (max-width: 800px) {
  .modal-container {
    height: 55vh;
  }
}

.form-content-body {
  height: 100%;
}
.modal-container {
  min-height: 600px;
}

/* Content page css overrides*/

.content-pages-panel >>> .fr-view a {
  color: #0696d7;
}
.content-pages-panel >>> .fr-view a:hover {
  color: #0056b3;
  text-decoration: none;
}

.content-pages-panel >>> div,
.content-pages-panel >>> li {
  font-size: 14px;
}
.content-page-container .preview-panel >>> .fr-view p,
.content-page-container,
.preview-panel,
>>> .fr-view,
li,
.content-page-container,
.preview-panel,
>>> .fr-view,
a,
.content-page-container .preview-panel >>> .fr-view a {
  color: #0696d7;
}
.content-page-container .preview-panel >>> .fr-view a:hover {
  color: #0056b3;
  text-decoration: none;
}
</style>